import { Reducer } from 'redux';
import {
    ActionTypes,
    GET_ROLES_REQUEST, GET_ROLES_SUCCESS, GET_ROLES_FAILURE,
    GET_ROLE_REQUEST, GET_ROLE_SUCCESS, GET_ROLE_FAILURE,
    ADD_ROLE_REQUEST, ADD_ROLE_SUCCESS, ADD_ROLE_FAILURE,
    EDIT_ROLE_REQUEST, EDIT_ROLE_SUCCESS, EDIT_ROLE_FAILURE,
    DELETE_ROLE_REQUEST, DELETE_ROLE_SUCCESS, DELETE_ROLE_FAILURE,
    SET_ADD_ROLE_POPUP, SET_EDIT_ROLE_POPUP, SET_DELETE_ROLE_POPUP,
    RESET_ROLE_STATE, PrivilegesProps
} from '../actions/roles.action';


export interface Role {
    uuid: string;
    name: string;
    privileges: PrivilegesProps[];
}

export interface State {
    roles: Role[];
    role: Role | {};
    loading: boolean;
    error: string | null;
    addRoleLoading: boolean;
    editRoleLoading: boolean;
    deleteRoleLoading: boolean;
    addPopupOpen: boolean;
    editPopupOpen: boolean;
    deletePopupOpen: boolean;

}

const initialState: State = {
    roles: [],
    role: {},
    loading: false,
    addRoleLoading: false,
    editRoleLoading: false,
    deleteRoleLoading: false,
    error: null,
    addPopupOpen: false,
    editPopupOpen: false,
    deletePopupOpen: false,
};

const reducer: Reducer<State, ActionTypes> = (state = initialState, action) => {
    switch (action.type) {
        case GET_ROLES_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_ROLES_SUCCESS:
            console.log(action.payload)
            return { ...state, roles: action.payload, loading: false, error: null };
        case GET_ROLES_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case GET_ROLE_REQUEST:
            return { ...state, loading: true, error: null };
        case GET_ROLE_SUCCESS:
            return { ...state, role: action.payload, loading: false, error: null };
        case GET_ROLE_FAILURE:
            return { ...state, loading: false, error: action.payload };
        case ADD_ROLE_REQUEST:
            return { ...state, addRoleLoading: true };
        case ADD_ROLE_SUCCESS:
            return { ...state, addRoleLoading: false };
        case ADD_ROLE_FAILURE:
            return { ...state, addRoleLoading: false };
        case EDIT_ROLE_REQUEST:
            return { ...state, editRoleLoading: true };
        case EDIT_ROLE_SUCCESS:
            return { ...state, editRoleLoading: false };
        case EDIT_ROLE_FAILURE:
            return { ...state, editRoleLoading: false };
        case DELETE_ROLE_REQUEST:
            return { ...state, deleteRoleLoading: true };
        case DELETE_ROLE_SUCCESS:
            return { ...state, deleteRoleLoading: false };
        case DELETE_ROLE_FAILURE:
            return { ...state, deleteRoleLoading: false };
        case SET_ADD_ROLE_POPUP:
            return { ...state, addPopupOpen: action.payload };
        case SET_EDIT_ROLE_POPUP:
            return { ...state, editPopupOpen: action.payload };
        case SET_DELETE_ROLE_POPUP:
            return { ...state, deletePopupOpen: action.payload };
        case RESET_ROLE_STATE:
            return {...initialState}
        default:
            return state;
    }
};

export default reducer;
